import { Feature } from "@turf/helpers"
import { get } from "lodash"
import { Post, PostData } from "providers/venue/types"
import { getFeatureIDByPath } from "utils/feature"

export const preparePostData = (
  post: Post,
  findOne: (id: string) => Feature
): PostData => {
  // Prepare Post
  const { venue_id, category_id } = post.properties
  const venue = findOne(venue_id)
  const category = findOne(category_id)
  const location = get(post, "properties.location")
  const path = location?.url
  const locationType = location?.type
  const featureId = getFeatureIDByPath(path)
  const isReferenceID = locationType === "reference-id"
  const feature = isReferenceID && featureId ? findOne(featureId) : null

  return {
    ...post,
    properties: {
      ...post.properties,
      category,
      feature,
      venue,
    },
  }
}
